module.exports = __webpack_public_path__ + "img/card-vital-surround.952184ab.webp";